module.exports = __webpack_public_path__ + "img/draw-title.500313ee.png";